import Reveal from '@/components/base/Reveal';
import { featuredStats } from '@/mocks/results';

export default function ResultsStrip() {
  return (
    <section className="relative py-10 md:py-14">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {featuredStats.map((s, i) => (
            <Reveal key={s.label} delay={i * 80}>
              <div className="h-full rounded-xl border border-white/8 bg-background-100/60 p-6 text-center">
                <p className="font-heading font-extrabold text-3xl md:text-4xl text-primary-400">
                  {s.value}
                </p>
                <p className="mt-2 text-sm text-foreground-600">{s.label}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={200}>
          <p className="mt-6 text-center text-xs text-foreground-600 max-w-2xl mx-auto">
            Results shown are examples from selected client experiences. Past performance does not
            guarantee future results.
          </p>
        </Reveal>
      </div>
    </section>
  );
}